import React, { useState, useEffect } from 'react';
import { Form, Select } from 'antd';
import * as S from './styles';
import { SearchInputMunicipios } from '../SearchInputMunicipios';
import { SearchInputModelosVeiculos } from '../SearchInputModelosVeiculos';

export default function EditForm({ item, list, form }) {
  const { Option } = Select;
  const [focus, setFocus] = useState('');
  const uf = Form.useWatch(item.firstId || item.nome, form);
  const [marcaCodigo, setMarcaCodigo] = useState('');

  const setMarca = (name, e) => {
    const value = String(e).split('#');
    setMarcaCodigo(value[0]);
    setValueForm(name, e);
  };

  const setSiglaUF = async (name, e) => {
    setValueForm(name, e);
    setValueForm(item.secondId, null);
  };

  useEffect(() => {
    if (!item.firstInitialValue) return;

    if (item.nome === 'marcaModelo') {
      setMarca(item.firstId, item.firstInitialValue);
    }
  }, [item.firstInitialValue]);

  const setValueForm = (name, value) => {
    form.setFields([
      {
        name,
        value,
      },
    ]);
  };

  const firstLabelColor = () => (focus === item.nome ? '#000000' : '#707070');
  const secondLabelColor = () => (item.nome === 'cpf' ? '#B2BBBF' : firstLabelColor());

  const itemBorder = item.border ?? '';

  const getUFeMunicipioComponent = () => (
      <S.DivSelect tamanho={item.width}>
        <Form.Item
          name={item.firstId}
          label={
            <p
              style={{
                color: firstLabelColor(),
                margin: '0',
              }}
            >
              {item.firstLabel}
            </p>
          }
          initialValue={item.firstInitialValue}
          style={{
            fontWeight: 'bold',
            fontSize: '14px',
            lineHeight: '16px',
            width: '50%',
          }}
        >
          <S.InputSelect
            id={item.firstId}
            showSearch
            optionFilterProp="children"
            onBlur={() => setFocus('')}
            onFocus={e => setFocus(e.target.id)}
            bordered={false}
            onChange={e => setSiglaUF(item.firstId, e)}
            style={{ background: '#FFFFFF', border: itemBorder }}
            disabled={item.bloqueado}
          >
            {list?.map(item => (
              <Option key={item.uf} value={item.uf}>
                {item.uf}
              </Option>
            ))}
          </S.InputSelect>
        </Form.Item>
        <Form.Item
          name={item.secondId}
          initialValue={item.secondInitialValue}
          style={{
            fontWeight: 'bold',
            fontSize: '14px',
            lineHeight: '16px',
            display: 'flex',
            width: '50%',
            marginLeft: '10px',
          }}
          label={
            <p
              style={{
                color: secondLabelColor(),
                margin: '0',
              }}
            >
              {item.secondLabel}
            </p>
          }
        >
          <SearchInputMunicipios
            id={item.secondId}
            uf={uf}
            bordered={false}
          />
        </Form.Item>
      </S.DivSelect>
    );

  const getMarcaEModeloComponent = () => (
      <S.DivSelect tamanho={item.width}>
        <Form.Item
          name={item.firstId}
          label={
            <p
              style={{
                color: firstLabelColor(),
                margin: '0',
              }}
            >
              {item.firstLabel}
            </p>
          }
          initialValue={item.firstInitialValue}
          style={{
            fontWeight: 'bold',
            fontSize: '14px',
            lineHeight: '16px',
            width: '50%',
          }}
        >
          <S.InputSelect
            id={item.firstId}
            showSearch
            optionFilterProp="children"
            onBlur={() => setFocus('')}
            onFocus={e => setFocus(e.target.id)}
            bordered={false}
            onChange={e => setMarca(item.firstId, e)}
            disabled={item.bloqueado}
          >
            {list?.map(item => (
              <Option
                key={item.codigo}
                value={`${item.codigo}#${item.descricao}`}
              >
                {item.descricao}
              </Option>
            ))}
          </S.InputSelect>
        </Form.Item>
        <Form.Item
          name={item.secondId}
          initialValue={item.secondInitialValue}
          style={{
            fontWeight: 'bold',
            fontSize: '14px',
            lineHeight: '16px',
            display: 'flex',
            width: '50%',
            marginLeft: '10px',
          }}
          label={
            <p
              style={{
                color: secondLabelColor(),
                margin: '0',
              }}
            >
              {item.secondLabel}
            </p>
          }
        >
          <SearchInputModelosVeiculos
            codigoMarca={marcaCodigo}
            initialValue={item.secondInitialValue}
            bordered={false}
            onChangeCallBack={e => setValueForm(item.secondId, e)}
            disabled={item.bloqueado}
            style={{ background: '#FFFFFF', border: itemBorder }}
          />
        </Form.Item>
      </S.DivSelect>
    );

  const createOption = (key, value, children) => (
    <Option key={key} value={value}>
      {children}
    </Option>
  );

  const renderOption = (campo, receberId) => {
    if (campo.codigoIbge) {
      return createOption(campo.uf, campo.uf, campo.uf);
    }

    let value = campo.descricao;

    if (receberId) value = `${campo.codigo}#${campo.descricao}`;

    return createOption(campo.codigo, value, campo.descricao);
  };

  const onBlur = e => {
    const invalid = e.target.value?.toString()?.includes('inválid');
    if (invalid) {
      setValueForm(item.nome, null);
    }
    setFocus('');
  };

  return item.select === 'double' ? (
    item.nome === 'marcaModelo' ? (
      getMarcaEModeloComponent()
    ) : (
      getUFeMunicipioComponent()
    )
  ) : (
    <Form.Item
      name={item.nome}
      normalize={value => (value ?? '').toUpperCase()}
      label={
        <p
          style={{
            color: secondLabelColor(),
            margin: '0',
          }}
        >
          {item.label}
        </p>
      }
      initialValue={item.initialValue}
      style={{
        fontWeight: 'bold',
        fontSize: '14px',
        lineHeight: '16px',
        width: item.width,
        display: item.hide ? 'none' : 'flex',
      }}
    >
      {item.mask ? (
        <S.InputStyled
          mask={item.mask}
          id={item.nome}
          autoCapitalize
          onBlur={() => setFocus('')}
          onFocus={e => setFocus(e.target.id)}
          bordered={false}
          style={{ background: '#FFFFFF', border: itemBorder }}
        />
      ) : item.select === 'single' ? (
        <S.InputSelect
          id={item.nome}
          showSearch
          optionFilterProp="children"
          onBlur={() => setFocus('')}
          onFocus={e => setFocus(e.target.id)}
          bordered={false}
          onChange={e => setValueForm(item.nome, e)}
          style={{ background: '#FFFFFF', border: itemBorder }}
          disabled={item.bloqueado}
        >
          {item?.list?.map(campo => renderOption(campo, item.receberId))}
        </S.InputSelect>
      ) : (
        <S.InputStyled
          id={item.nome}
          onBlur={onBlur}
          onFocus={e => setFocus(e.target.id)}
          bordered={false}
          style={{ background: '#FFFFFF', border: itemBorder }}
          onChange={item.onChange}
          disabled={item.bloqueado}
        />
      )}
    </Form.Item>
  );
}
